<div class="flex flex-col flex-auto min-w-0">
    <div class="flex flex-col flex-auto min-w-0 bg-card dark:bg-transparent">
        <div class="relative flex flex-col sm:flex-row flex-0 sm:items-center py-8 px-6 md:px-8 border-b ">
            <div class="text-4xl font-extrabold tracking-tight">
                Dossiers d'interventions
                <div>
                    <input
                        class="border w-full rounded-lg p-2 text-md border-gray-400"
                        type="text"
                        placeholder="Recherche"
                        matInput
                        (change)="search($event)"
                        (keyup)="search($event)"
                    />
                </div>
            </div>

            <div class="flex flex-grow justify-end items-center mt-6 sm:mt-0 sm:ml-4 text-right">
                <button class="ml-4" mat-flat-button [color]="'primary'" (click)="add()">
                    <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                    <span class="ml-2 mr-1">Ajouter</span>
                </button>
            </div>
        </div>

        <div class="flex flex-auto overflow-hidden">
            <div class="flex flex-col flex-auto sm:mb-18 overflow-hidden sm:overflow-y-auto">
                <div class="grid">
                    <div class="table-grid-dossiers-interventions z-10 sticky top-0 grid gap-4 py-4 px-6 md:px-8 shadow text-md font-semibold text-secondary bg-gray-50 dark:bg-black dark:bg-opacity-5">
                        <div>Numéro de dossier</div>
                        <div>Compagnie d'assurance</div>
                        <div>Nom de l'assuré</div>
                        <div class="right-0">Date de la perte</div>
                    </div>
                    <ng-container *ngFor="let dossierIntervention of dossiersInterventions; trackBy: trackByFn">
                        <div *ngIf="!ajout" class="table-grid-dossiers-interventions grid items-center gap-4 py-3 px-6 md:px-8 border-b">
                            <div class="">
                                <a [routerLink]="['/dossiers-interventions', dossierIntervention.id]" class="min-w-10 min-h-7 h-7 px-2 leading-6" mat-stroked-button>
                                    {{dossierIntervention.no_dossier}}
                                </a>
                            </div>
                            <div class="">{{dossierIntervention.compagnie_assurance}}</div>
                            <div class="">{{dossierIntervention.nom_assure}}</div>
                            <div class="">{{dossierIntervention.date_perte}}</div>
                        </div>
                        <div class="grid" *ngIf="ajout">
                            <ng-container *ngIf="currentDossierIntervention?.id === dossierIntervention.id">
                                <ng-container *ngTemplateOutlet="rowDetailsTemplate; context: {$implicit: dossierIntervention}"></ng-container>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>

                <ng-template #rowDetailsTemplate let-dossierIntervention>
                    <div class="shadow-lg overflow-hidden">
                        <div class="flex border-b mt-4">
                            <div class="w-full h-full">
                                <div class="text-right mx-4">
                                    <mat-icon class="hover:opacity-75 hover:cursor-pointer" [svgIcon]="'heroicons_outline:x-circle'" (click)="closeAjout();"></mat-icon>
                                </div>
                                <app-form-dossier-intervention [currentDossierIntervention]="currentDossierIntervention" [users]="users" (submitEvent)="onFormSubmit();" (valueChangedEvent)="this.unsavedChanges = $event"></app-form-dossier-intervention>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
  </div>
